import { routes } from "config/routes";
import useStore from "config/store";

export default function useCompanySelection() {
  const setPreviewSrc = useStore(state => state.setPreviewSrc);
  const setCompanySelected = useStore(state => state.setCompanySelected);
  const setAccountingFirmSelected = useStore(state => state.setAccountingFirmSelected);
  const setCompanyData = useStore(state => state.setCompanyData);
  const setDocumentsSelected = useStore(state => state.setDocumentsSelected);
  const setDocuments = useStore(state => state.setDocuments);
  const setTotalDocuments = useStore(state => state.setTotalDocuments);

  const saveCompany = (companyData: CompaniesWithAccountingFirm) => {
    if (!companyData.id) return;

    const { accountingFirm, ...company } = companyData;
    setDocumentsSelected([]);
    setDocuments([]);
    setTotalDocuments(0);
    setCompanyData(companyData);
    setCompanySelected({
      id: company.id,
      name: company.name,
      internalReference: company.internalReference,
    });
    if (accountingFirm) {
      setAccountingFirmSelected({ id: accountingFirm.id, name: accountingFirm.name });
    }
    setPreviewSrc([]);
    routes.navigate(`/company/${companyData.id}`);
  };

  return { saveCompany };
}
